import { motion } from "framer-motion";
import { ChatCircleDots, Compass, Target, TrendUp, Clock, ArrowRight } from "@phosphor-icons/react";

const DOOR = "https://customer-assets.emergentagent.com/job_fincorp-strategy/artifacts/u97wya7o_Door%20image.png";

const PROCESS = [
  { n: "1", t: "Share", d: "Your goals", icon: ChatCircleDots },
  { n: "2", t: "Discover", d: "Our platform", icon: Compass },
  { n: "3", t: "Match", d: "Perfect fits", icon: Target },
  { n: "4", t: "Grow", d: "Your business journey", icon: TrendUp },
];

export function QuestionnaireTeaser({ onStart }) {
  return (
    <section className="px-6 md:px-12 lg:px-20 py-20 md:py-28 border-t border-white/10" data-testid="questionnaire-teaser">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* LEFT */}
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <p className="eyebrow mb-5">Discover what's right for you</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
            Not sure where to start? Let's find the right <span className="gold-text italic">franchise partnership.</span>
          </h2>
          <p className="text-ebg-muted mt-7 text-lg leading-relaxed max-w-md">
            Answer a few quick questions and we'll curate a portfolio of premium opportunities tailored to your ambitions.
          </p>
          <button onClick={onStart} data-testid="teaser-start-journey-btn"
            className="btn-gold rounded-full px-8 py-4 font-semibold mt-9 inline-flex items-center gap-2 transition-transform hover:scale-[1.03]">
            Start Your Journey <ArrowRight size={18} weight="bold" />
          </button>
          <p className="text-ebg-muted text-sm mt-5 flex items-center gap-2"><Clock size={16} className="text-gold" /> Takes less than 2 minutes</p>
        </motion.div>

        {/* RIGHT — door scene background */}
        <motion.div initial={{ opacity: 0, scale: 0.96 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-3xl border border-gold/15 min-h-[440px]">
          <img src={DOOR} alt="A doorway opening to your next opportunity" className="absolute inset-0 w-full h-full object-cover object-right" />
          <div className="absolute inset-0 bg-gradient-to-r from-navy-950 via-navy-950/85 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy-950/70 via-transparent to-transparent" />

          <div className="relative p-8 md:p-10 h-full flex flex-col">
            <p className="eyebrow mb-4">Questionnaire</p>
            <h3 className="font-display text-3xl md:text-4xl text-white leading-tight max-w-xs">
              Your next opportunity is just a few answers away.
            </h3>

            <motion.div
              className="mt-auto pt-12 grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-[260px] sm:max-w-md rounded-2xl sm:rounded-none bg-navy-950/45 sm:bg-transparent backdrop-blur-[2px] sm:backdrop-blur-0 p-3 sm:p-0 -ml-3 sm:ml-0"
              initial="hidden" whileInView="show" viewport={{ once: true }}
              variants={{ hidden: {}, show: { transition: { staggerChildren: 0.1 } } }}>
              {PROCESS.map((s) => (
                <motion.div key={s.n} variants={{ hidden: { opacity: 0, y: 16 }, show: { opacity: 1, y: 0 } }} className="text-center">
                  <div className="mx-auto grid place-items-center w-12 h-12 rounded-full border border-gold/40 bg-navy-950/40 backdrop-blur-sm text-gold mb-3">
                    <s.icon size={22} weight="light" />
                  </div>
                  <p className="text-sm text-white font-medium">{s.n}. {s.t}</p>
                  <p className="text-[0.7rem] text-ebg-muted mt-0.5 leading-tight">{s.d}</p>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
